import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "size", "error", "label", "placeholder", "hint", "LabelProps", "SelectProps", "selectProps", "scroll", "fullWidth", "showSelectionKey", "value", "multiple", "hideMenuItemsActions", "onChange", "readOnly", "disabled", "showClearIcon"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PT from 'prop-types';
import { InputSize } from '../../utils/types';
import { intrinsicComponent, objectValues } from '../../utils/functions';
import Label from '../label';
import { propTypes as labelPropTypes } from '../label/label.component';
import Select from '../select';
import { propTypes as selectPropTypes } from '../select/select.component';
import FormHint from '../form-hint';
import Styled from './select-group.styles';
var SelectGroup = intrinsicComponent(function (_ref, ref) {
  var children = _ref.children,
    size = _ref.size,
    error = _ref.error,
    label = _ref.label,
    placeholder = _ref.placeholder,
    hint = _ref.hint,
    LabelPropsData = _ref.LabelProps,
    SelectPropsData = _ref.SelectProps,
    selectProps = _ref.selectProps,
    _ref$scroll = _ref.scroll,
    scroll = _ref$scroll === void 0 ? true : _ref$scroll,
    fullWidth = _ref.fullWidth,
    showSelectionKey = _ref.showSelectionKey,
    value = _ref.value,
    multiple = _ref.multiple,
    hideMenuItemsActions = _ref.hideMenuItemsActions,
    onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    disabled = _ref.disabled,
    showClearIcon = _ref.showClearIcon,
    rest = _objectWithoutProperties(_ref, _excluded);
  var renderLabel = function renderLabel() {
    if (label) {
      if (typeof label === 'function') {
        return label({
          error: error
        });
      }
      if (_typeof(label) === 'object') {
        return label;
      }
      return /*#__PURE__*/React.createElement(Label, _extends({
        error: error
      }, LabelPropsData || {}), label);
    }
    return null;
  };
  var renderHint = function renderHint() {
    if (hint) {
      if (typeof hint === 'function') {
        return hint({
          error: error
        });
      }
      if (_typeof(hint) === 'object') {
        return hint;
      }
      return /*#__PURE__*/React.createElement(FormHint, {
        error: error
      }, hint);
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(Styled.SelectGroup, _extends({}, rest, {
    ref: ref
  }), renderLabel(), /*#__PURE__*/React.createElement(Select, _extends({
    error: error,
    value: value,
    size: size,
    scroll: scroll,
    onChange: onChange,
    multiple: multiple,
    fullWidth: Boolean(fullWidth)
  }, SelectPropsData || {}, {
    selectProps: selectProps,
    readOnly: readOnly,
    disabled: disabled,
    placeholder: placeholder,
    showSelectionKey: showSelectionKey,
    hideMenuItemsActions: hideMenuItemsActions,
    showClearIcon: showClearIcon
  }), children), renderHint());
});
SelectGroup.defaultProps = {
  error: false,
  fullWidth: false,
  readOnly: false,
  disabled: false,
  scroll: true,
  hideMenuItemsActions: false
};
var size = selectPropTypes.size,
  restSelectPropTypes = _objectWithoutProperties(selectPropTypes, ["size"]);
SelectGroup.propTypes = _objectSpread(_objectSpread({}, restSelectPropTypes), {}, {
  // Extends from SelectProps: multiple, error, children, value, onChange
  fullWidth: PT.bool,
  size: PT.oneOf(objectValues(InputSize)),
  label: PT.node,
  hint: PT.node,
  LabelProps: PT.exact(labelPropTypes),
  SelectProps: PT.exact(selectPropTypes),
  selectProps: PT.object,
  readOnly: PT.bool,
  scroll: PT.bool,
  showSelectionKey: PT.bool,
  disabled: PT.bool
});
export default SelectGroup;